import Color from "color";

export function rgb(color: string): `${number}, ${number}, ${number}` {
  try {
    // Check if the color is a valid value
    if (!color || color === "-1" || color.startsWith("-")) {
      // Return a fallback color (black)
      return "0, 0, 0";
    }
    return Color(color).rgb().array().join(", ") as `${number}, ${number}, ${number}`;
  } catch (error) {
    // Return a fallback color (black)
    return "0, 0, 0";
  }
}
